import { open as openModal } from 'modal';
import {
  getCookie,
  isMobile,
  debounce,
  isElementXPercentInViewport
} from './modules/util';
import lj from './lumberjack';
import AutoNumeric from 'AutoNumeric';

window.openModal = openModal;

const elementStrings = {
  gstCalcForm: 'form#gst-calculator-form',
  cogsAmtInput: 'input#cogs-amount',
  cogsClearButton: 'span#cogs-clear-btn',
  cogsInputTooltip: '.cogs-input-tooltip',
  profitRatioInput: 'input#profit-ratio',
  gstSlabPanel: '.gst-slab-panel',
  gstCalcIllust: '.gst-calc-illustration',
  calculatorResult: '.calculator-result',
  gstAmtResPar: '.gst-amount-result',
  gstAmtResult: '.gst-amount-result > p',
  totalProfitAmtResPar: '.profit-ratio-result',
  totalProfitAmtRes: '.profit-ratio-result > p',
  totalSPResultPar: '.sp-amount-result',
  totalSPResult: '.sp-amount-result span:last-child',
  profitRatioToggle: 'a.link#profit-ratio-toggle',
  profitRatioPanel: '.profit-ratio-panel',
  gstRatePanel: '.gst-rate-panel',
  checkBreakupBTN: 'a.link.check-breakup-btn',
  cogsValueModal: '.cogs-value-modal > p.dark',
  profitRatioValModal: '.profit-ratio-val-modal',
  gstTitleValModal: '.gst-val-modal > p.dark',
  igstValModal: '.igst-value-modal',
  cgstValModal: '.cgst-value-modal',
  sgstValModal: '.sgst-value-modal',
  totSPValModal: '.shaded.strip:last-child > p.tot-sp',
  gstToggleSwitch: 'label.switch.gst-toggle-switch',
  navItem: 'ul.gst-nav-list',
  faqTitles: '.faqs-tab-title',
  blogItems: '.gst-blogs#testimonials .testimonials .scroller .wrapper > .item',
  invoicesSignUpCTA: '#invoices-info .button-anchor.signupCTA',
  calculateGSTCTA: '#gst-calc-steps .button-anchor.calculateGSTCTA',
  calcGSTFixedBTN: 'a.mob.calc-gst-fixed',
  get allTypeInputs() {
    return `${this.cogsAmtInput}, ${this.profitRatioInput}`;
  },
  navbar: 'nav.gst-nav'
};

const gstCalcForm = $(elementStrings.gstCalcForm);
const cogsAmtInput = $(elementStrings.cogsAmtInput);
const cogsClearButton = $(elementStrings.cogsClearButton);
const cogsInputTooltip = $(elementStrings.cogsInputTooltip);
const profitRatioInput = $(elementStrings.profitRatioInput);
const gstSlabPanel = $(elementStrings.gstSlabPanel);
const gstSlabButtons = gstSlabPanel.children();
const gstCalcIllust = $(elementStrings.gstCalcIllust);
const calculatorResult = $(elementStrings.calculatorResult);
const gstAmtResPar = $(elementStrings.gstAmtResPar);
const gstAmtResult = $(elementStrings.gstAmtResult);
const totalProfitAmtResPar = $(elementStrings.totalProfitAmtResPar);
const totalProfitAmtRes = $(elementStrings.totalProfitAmtRes);
const totalSPResultPar = $(elementStrings.totalSPResultPar);
const totalSPResult = $(elementStrings.totalSPResult);
const profitRatioToggle = $(elementStrings.profitRatioToggle);
const profitRatioPanel = $(elementStrings.profitRatioPanel);
const gstRatePanel = $(elementStrings.gstRatePanel);
const checkBreakupBTN = $(elementStrings.checkBreakupBTN);
const cogsValueModal = $(elementStrings.cogsValueModal);
const profitRatioValModal = $(elementStrings.profitRatioValModal);
const gstTitleValModal = $(elementStrings.gstTitleValModal);
const igstValModal = $(elementStrings.igstValModal);
const cgstValModal = $(elementStrings.cgstValModal);
const sgstValModal = $(elementStrings.sgstValModal);
const totSPValModal = $(elementStrings.totSPValModal);
const gstToggleSwitch = $(elementStrings.gstToggleSwitch);
const navItem = $(elementStrings.navItem);
const faqTitles = $(elementStrings.faqTitles);
const blogItems = $(elementStrings.blogItems);
const invoicesSignUpCTA = $(elementStrings.invoicesSignUpCTA);
const calculateGSTCTA = $(elementStrings.calculateGSTCTA);
const calcGSTFixedBTN = $(elementStrings.calcGSTFixedBTN);
const allTypeInputs = $(elementStrings.allTypeInputs);
const windowEl = $(window);
const navbar = $(elementStrings.navbar);
const navbarCTA = navbar.find(
  '.container.nomob > .button-anchor.calculateGSTCTA'
);

const fontSizeSmall = 16;
const fontSizeMid = 24;
const fontSizeLarge = 54;

let cogsAmount = null;
let isCogsClearBtnHidden = true;
let cogsTooltipVisible = true;
let gstProfitRatio = null;
let gstSlabRate = 5;
let cgstSlabRate = 2.5;
let calculatorResultHidden = true;
let totalProfitAmt = null;
let gstTotalAmount = null;
let cgstTotalAmount = null;
let vosAmount = null;
let totSPAmount = null;
let igstSelected = false;
let ischeckBKPBTNActive = false;

const clientID = getCookie('clientId');
// const stickyNavTop = navbar.offset().top;

lj.setupLJ();

const anElement = new AutoNumeric(elementStrings.cogsAmtInput, null, {
  digitalGroupSpacing: '2',
  minimumValue: 0,
  maximumValue: 1000000000,
  emptyInputBehavior: 'null'
});

if (clientID) {
  const cogsTooltipViewed = window.localStorage.getItem(
    `${clientID}--cogsTooltipViewed`
  );
  if (!cogsTooltipViewed) {
    cogsInputTooltip.addClass('visible');
    window.localStorage.setItem(`${clientID}--cogsTooltipViewed`, true);
  } else cogsTooltipVisible = false;
} else {
  cogsInputTooltip.addClass('visible');
}

const formatNumToCurrStr = num => {
  return num == null
    ? ''
    : num.toLocaleString('en-IN', {
        maximumFractionDigits: 2
      });
};

const updateGSTAmtOnScreen = (setToInitial = false) => {
  if (setToInitial) gstAmtResult.text('₹ 0.00');
  else {
    const gstTotalAmtString = formatNumToCurrStr(gstTotalAmount);
    gstAmtResult.text(`₹ ${gstTotalAmtString}`);
  }
  if (isMobile()) resizeToFit(gstAmtResPar, gstAmtResult, fontSizeSmall);
  else resizeToFit(gstAmtResPar, gstAmtResult, fontSizeMid);
};

const calculateGSTAmount = () => {
  if (gstSlabRate == null || vosAmount == null) {
    gstTotalAmount = null;
    updateGSTAmtOnScreen(true);
  } else {
    gstTotalAmount = (vosAmount * gstSlabRate) / 100;
    cgstTotalAmount = gstTotalAmount / 2;
    updateGSTAmtOnScreen();
  }
};

const updateTotalProfitAmtOnScreen = (setToInitial = false) => {
  if (setToInitial) totalProfitAmtRes.text('₹ 0.00');
  else {
    const totalProfitAmtStr = formatNumToCurrStr(totalProfitAmt);
    totalProfitAmtRes.text(`₹ ${totalProfitAmtStr}`);
  }
  if (isMobile())
    resizeToFit(totalProfitAmtResPar, totalProfitAmtRes, fontSizeSmall);
  else resizeToFit(totalProfitAmtResPar, totalProfitAmtRes, fontSizeMid);
};

const calculateTotalProfit = () => {
  if (gstProfitRatio == null || cogsAmount == null) {
    totalProfitAmt = null;
    updateTotalProfitAmtOnScreen(true);
  } else {
    totalProfitAmt = (cogsAmount * gstProfitRatio) / 100;
    updateTotalProfitAmtOnScreen();
  }
};

const updateTotalSPOnScreen = (setToInitial = false) => {
  if (setToInitial) {
    if (ischeckBKPBTNActive) {
      checkBreakupBTN.css('filter', 'grayscale(1) brightness(1.6)');
      checkBreakupBTN.children().css('filter', 'brightness(1.2)');
      checkBreakupBTN.css('cursor', 'default');
      ischeckBKPBTNActive = false;
    }
    totalSPResult.text(' 0.00');
  } else {
    const totSPAmountStr = ` ${formatNumToCurrStr(totSPAmount)}`;
    totalSPResult.text(totSPAmountStr);
    if (!ischeckBKPBTNActive) {
      checkBreakupBTN.css('filter', 'none');
      checkBreakupBTN.children().css('filter', 'none');
      checkBreakupBTN.css('cursor', 'pointer');
      ischeckBKPBTNActive = true;
    }
  }
  resizeToFit(
    totalSPResultPar,
    $(`${elementStrings.totalSPResultPar} > p`),
    fontSizeLarge
  );
};

const calculateTotalSP = () => {
  if (vosAmount == null || gstSlabRate == null) {
    totSPAmount = null;
    updateTotalSPOnScreen(true);
  } else {
    totSPAmount = vosAmount + (vosAmount * gstSlabRate) / 100;
    updateTotalSPOnScreen();
  }
};

const calculateFinalAmount = () => {
  calculateGSTAmount();
  calculateTotalProfit();
  calculateTotalSP();
};

const calculateVOSAmount = () => {
  if (cogsAmount == null) vosAmount = null;
  else if (gstProfitRatio == null) vosAmount = cogsAmount;
  else vosAmount = cogsAmount + (cogsAmount * gstProfitRatio) / 100;
};

// Setting and formatting GST Amount on input
cogsAmtInput.on('input', function() {
  const inputValStr = $(this).val() || '';
  const inputValStrFMT = inputValStr.replace(/,/gi, '');
  const inputValNum = inputValStrFMT.length
    ? Number(inputValStrFMT) === NaN
      ? null
      : Number(inputValStrFMT)
    : null;
  cogsAmount = inputValNum;
  if (cogsAmount == null) anElement.set(cogsAmount);
  calculateVOSAmount();
  if (isCogsClearBtnHidden && inputValNum) {
    cogsClearButton.removeClass('hide');
    isCogsClearBtnHidden = false;
  } else if (!isCogsClearBtnHidden && !inputValNum) {
    cogsClearButton.addClass('hide');
    isCogsClearBtnHidden = true;
  }
  if (calculatorResultHidden) {
    gstCalcIllust.addClass('fadeOut-right');
    calculatorResult.first().addClass('fadeIn-right');
    calculatorResultHidden = false;
  }
  calculateFinalAmount();
  if (cogsTooltipVisible) {
    cogsInputTooltip.removeClass('visible');
    cogsTooltipVisible = false;
  }
});

// Setting GST Slab rates on slab click
gstSlabPanel.on('click', function(event) {
  const gstSlabJQObj = $(event.target.closest('button'));
  const gstSlabChosen = gstSlabJQObj.length ? gstSlabJQObj : null;
  if (gstSlabChosen) {
    gstSlabButtons.each(function() {
      $(this).css('border', 'none');
      $(this).css('font-weight', 'normal');
      $(this).css('color', '#505050');
    });
    gstSlabChosen.css('border', '1px solid #0B70E7');
    gstSlabChosen.css('font-weight', '800');
    gstSlabChosen.css('color', '#0B70E7');
    gstSlabRate = Number(gstSlabChosen.text().slice(0, -1));
    cgstSlabRate = gstSlabRate / 2;
    calculateFinalAmount();

    lj.pushEvents({
      event_name: 'website.click_calculator_GST_slab',
      event_type: 'initiated',
      properties: {
        GST_slab_value: gstSlabRate
      }
    });
  }
});

// Toggle Profit ratio show button
profitRatioToggle.on('click', function() {
  $(this).addClass('hide');
  profitRatioPanel.fadeIn();

  lj.pushEvents({
    event_name: 'website.click_profit_ratio',
    event_type: 'initiated'
  });
});

// Processinput on profit ratio input
profitRatioInput.on('input', function() {
  if ($(this).val().length !== 0) {
    var max = parseInt($(this).attr('max'));
    var min = parseInt($(this).attr('min'));
    if ($(this).val() > max) $(this).val(max);
    else if ($(this).val() < min) $(this).val(min);

    gstProfitRatio = Number($(this).val());
  } else gstProfitRatio = null;
  calculateVOSAmount();
  calculateFinalAmount();
});

// COGS clear button click
cogsClearButton.on('click', function() {
  cogsAmtInput.val('');
  cogsAmount = null;
  anElement.set(null);
  $(this).addClass('hide');
  isCogsClearBtnHidden = true;
  calculateVOSAmount();
  calculateFinalAmount();
});

const switchCGSTIGSTOnScreen = () => {
  if (!igstSelected) {
    cgstValModal
      .children()
      .first()
      .text(`CGST ${cgstSlabRate}%`);
    cgstValModal
      .children()
      .last()
      .text(`₹ ${formatNumToCurrStr(cgstTotalAmount)}`);
    sgstValModal
      .children()
      .first()
      .text(`SGST ${cgstSlabRate}%`);
    sgstValModal
      .children()
      .last()
      .text(`₹ ${formatNumToCurrStr(cgstTotalAmount)}`);
    cgstValModal.removeClass('hide');
    sgstValModal.removeClass('hide');
    igstValModal.addClass('hide');
  } else {
    igstValModal
      .children()
      .first()
      .text(`IGST ${gstSlabRate}%`);
    igstValModal
      .children()
      .last()
      .text(`₹ ${formatNumToCurrStr(gstTotalAmount)}`);
    cgstValModal.addClass('hide');
    sgstValModal.addClass('hide');
    igstValModal.removeClass('hide');
  }
};

checkBreakupBTN.on('click', function() {
  if (totSPAmount != null) {
    cogsValueModal.text(`₹ ${formatNumToCurrStr(cogsAmount)}`);

    if (totalProfitAmt == null || gstProfitRatio == null)
      profitRatioValModal.addClass('hide');
    else {
      profitRatioValModal
        .children()
        .first()
        .text(`Profit (at ${gstProfitRatio}%)`);
      profitRatioValModal
        .children()
        .last()
        .text(`₹ ${formatNumToCurrStr(totalProfitAmt)}`);
      profitRatioValModal.removeClass('hide');
    }

    gstTitleValModal.text(`GST ${gstSlabRate}%`);

    switchCGSTIGSTOnScreen();

    totSPValModal.text(`₹ ${formatNumToCurrStr(totSPAmount)}`);

    openModal('.modal#gst-full-breakup-modal', '', closeCheckBreakupCallback);

    lj.pushEvents({
      event_name: 'website.click_calculator_breakup',
      event_type: 'initiated',
      properties: {
        Profit: totalProfitAmt,
        GST: gstTotalAmount,
        full_amount: totSPAmount
      }
    });
  }
});

gstToggleSwitch.on('change', function() {
  igstSelected = !igstSelected;
  switchCGSTIGSTOnScreen();

  lj.pushEvents({
    event_name: 'website.click_calculator_igst_toggle',
    event_type: 'initiated',
    properties: {
      IGST_toggle: igstSelected ? 'on' : 'off'
    }
  });
});

navItem.on('click', function() {
  if (document.body.classList) document.body.classList.remove('open-nav');
});

function resizeToFit(
  parentElement,
  childElement,
  defaultFS,
  minimizing = null
) {
  let nextFS;
  var fontSize = childElement.css('font-size');
  if (!parentElement || !childElement || !defaultFS) return;
  if (minimizing == null)
    minimizing = childElement.width() >= parentElement.width();
  if (minimizing && childElement.width() >= parentElement.width()) {
    nextFS = Math.min(defaultFS, parseFloat(fontSize) - 1);
    childElement.css('font-size', nextFS);
    resizeToFit(parentElement, childElement, defaultFS, true);
  } else if (!minimizing && childElement.width() + 50 < parentElement.width()) {
    nextFS = Math.min(defaultFS, parseFloat(fontSize) + 1);
    childElement.css('font-size', nextFS);
    if (nextFS === defaultFS) return;
    resizeToFit(parentElement, childElement, defaultFS, false);
  }
}

// Instrumentation
cogsAmtInput.on('click', function() {
  lj.pushEvents({
    event_name: 'website.click_calculator_input',
    event_type: 'initiated'
  });
});

cogsAmtInput.on(
  'keyup',
  debounce(function() {
    const inputValStr = $(this).val() || '';
    const inputValStrFMT = inputValStr.replace(/,/gi, '');
    const inputValNum = inputValStrFMT.length
      ? Number(inputValStrFMT) === NaN
        ? null
        : Number(inputValStrFMT)
      : null;
    lj.pushEvents({
      event_name: 'website.calculator_input_value',
      event_type: 'initiated',
      properties: {
        calc_input_value: inputValNum
      }
    });
  }, 1500)
);

profitRatioInput.on(
  'keyup',
  debounce(function() {
    const inputValStr = $(this).val();
    const inputValNum = inputValStr.length
      ? Number(inputValStr) === NaN
        ? null
        : Number(inputValStr)
      : null;
    lj.pushEvents({
      event_name: 'website.calculator_profit_ratio_value',
      event_type: 'initiated',
      properties: {
        profit_ratio_input_value: inputValNum
      }
    });
  }, 1500)
);

faqTitles.on('click', function() {
  lj.pushEvents({
    event_name: 'website.click_calculator_faq',
    event_type: 'initiated'
  });
});

blogItems.on('click', function() {
  const blogTitle = $(this)
    .find('.blog > .blog-title')
    .text();
  lj.pushEvents({
    event_name: 'website.click_calculator_blog',
    event_type: 'initiated',
    properties: {
      blog_title: blogTitle
    }
  });
});

invoicesSignUpCTA.on('click', function() {
  lj.pushEvents({
    event_name: 'website.click_calculator_signup',
    event_type: 'initiated'
  });
});

calculateGSTCTA.on('click', function() {
  lj.pushEvents({
    event_name: 'website.click_calculator_calculate',
    event_type: 'initiated'
  });
});

function closeCheckBreakupCallback() {
  lj.pushEvents({
    event_name: 'website.click_calculator_breakup_close',
    event_type: 'initiated',
    properties: {
      Profit: totalProfitAmt,
      GST: gstTotalAmount,
      full_amount: totSPAmount
    }
  });
}

window.addEventListener(
  'scroll',
  debounce(() => {
    handleDataLakeEvents(gstCalcForm);
  }, 100)
);

let hasCalcDisplayEventFired = false;
function handleDataLakeEvents(element) {
  if (
    !hasCalcDisplayEventFired &&
    element &&
    isElementXPercentInViewport(element.get(0), 100)
  ) {
    lj.pushEvents({
      event_name: 'website.display_calculator',
      event_type: 'success'
    });
  }
}
